import "core-js/modules/es.iterator.constructor.js";
import "core-js/modules/es.iterator.for-each.js";
import "core-js/modules/es.iterator.map.js";
import { handleHttp, transformStr3, getformdataList } from "@/utils/utils";
import "../../assets/css/swiper.min.css";
export default {
  name: 'treasureList',
  data() {
    return {
      list: [],
      onLoad: true,
      scale: 1,
      isPc: false,
      pcTitleTop: 0,
      pcBottomLeft: 0,
      showBottom: false
    };
  },
  methods: {
    // 获取数据
    getData() {
      this.$api.getFormList(this.$route.query.fid, '389a5fe7e0c1d2bc4e188262cabe1349aa5084d3028db91d73d6a5f2391a6610').then(res => {
        if (res.total > 0) {
          let list = res.data.map(item => {
            let itemformdata = item.formData;
            let itemformat = {};
            Object.keys(itemformdata).forEach(key => {
              itemformat[transformStr3(itemformdata[key].alias)] = getformdataList(itemformdata[key]);
            });
            item.itemformdata = itemformat;
            return item;
          });
          this.list = list;
          console.log(this.list);
        }
      });
    },
    openUrl(url) {
      if (navigator.userAgent.toLowerCase().indexOf('chaoxingstudy') > -1) {
        jsBridge.postNotification('CLIENT_OPEN_URL', {
          'title': '',
          'loadType': '1',
          //打开方式，0在本页面打开，1使用客户端webview打开新页面，2打开系统浏览器
          'webUrl': url,
          'toolbarType': '2'
        });
        return;
      }
      window.open(url);
    },
    // 宽度
    setWidth() {
      if (window.innerWidth > 880 && window.innerWidth < 1500) {
        this.scale = window.innerWidth / 1500;
        this.pcBottomLeft = (window.innerWidth - 1320 * this.scale) / 2;
      }
      if (window.innerWidth > 880) {
        this.isPc = true;
      }
      this.pcTitleTop = window.innerHeight - 600 * this.scale > 0 ? (window.innerHeight - 600 * this.scale) * 0.2 : 50;
    }
  },
  created() {
    this.setWidth();
    this.getData();
    let list = ['swiper.min.js', 'swiper.animate.min.js', 'three83.min.js'];
    list.map(item => {
      let oScript = document.createElement('script');
      oScript.type = 'text/javascript';
      oScript.src = `js/treasureList/${item}`;
      document.body.appendChild(oScript);
    });
    document.body.style.overflow = 'hidden';
    let oScript2 = document.createElement('script');
    oScript2.type = 'text/javascript';
    oScript2.src = `js/360/jquery-1.11.0.min.js`;
    document.body.appendChild(oScript2);
  },
  mounted() {
    let that = this;
    this.$nextTick(() => {
      window.addEventListener('load', e => {
        setTimeout(() => {
          that.onLoad = true;
          let oScript3 = document.createElement('script');
          oScript3.type = 'text/javascript';
          oScript3.src = `js/treasureList/base.js`;
          document.body.appendChild(oScript3);
          setTimeout(() => {
            that.showBottom = true;
          }, 500);
        }, 500);
      });
    });
  },
  computed: {}
};